// Thumbnail strip for the product gallery: clicking a thumb scrolls the snap track; scrolling the track updates the active thumb.
class SProductGallery extends HTMLElement {
  #ac;
  #frame = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    const track = this.querySelector('[data-gallery-track]');
    if (!track) return;

    const slides = () => Array.from(track.children);
    const thumbs = () => Array.from(this.querySelectorAll('[data-gallery-thumb]'));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb || !this.contains(thumb)) return;
      const index = Number(thumb.dataset.galleryThumb);
      const slide = slides()[index];
      if (!slide) return;
      slide.scrollIntoView({ block: 'nearest', inline: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      this.#setActive(thumbs(), index);
    }, { signal });

    track.addEventListener('scroll', () => {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => {
        const width = track.clientWidth || 1;
        const index = Math.round(Math.abs(track.scrollLeft) / width);
        this.#setActive(thumbs(), index);
      });
    }, { signal, passive: true });
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.#frame);
    this.#ac?.abort();
  }

  #setActive(thumbs, index) {
    thumbs.forEach((thumb, i) => {
      thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  }
}

if (!customElements.get('s-product-gallery')) {
  customElements.define('s-product-gallery', SProductGallery);
}
